import { Component, Input } from "@angular/core";

import { APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-mech-engine",
	templateUrl: "./mech-engine.component.html",
	styleUrls: ["./mech-engine.component.scss"]
})
export class MechEngineComponent {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;

	constructor(private api: ApiService) { }

	async UpdateAltEngine() {
		await this.api.UpdateAltEngine(this.asset.asset_id, this.asset.alt_engine);
	}

}
